import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './home/home.component';
import { SliderComponent } from './home/slider/slider.component';
import { ServicesComponent } from './home/services/services.component';
import { NewSolutionsComponent } from './home/new-solutions/new-solutions.component';
import { NewInvestmentsComponent } from './home/new-investments/new-investments.component';
import { BaseComponent } from './base/base.component';

import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { FormSubmittedComponent } from './form-submitted/form-submitted.component';
import { SharedModule } from './shared/shared.module';
import { StartingPointComponent } from './home/starting-point/starting-point.component';
import { AchievementComponent } from './home/achievement/achievement.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    SliderComponent,
    ServicesComponent,
    NewSolutionsComponent,
    NewInvestmentsComponent,
    BaseComponent,
    DisclaimerComponent,
    FormSubmittedComponent,
    StartingPointComponent,
    AchievementComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
